import {
  type BadgeProps,
  type ButtonProps,
  createPolymorphicComponent,
  Badge as MantineBadge,
  type MantineStyleProps,
} from "@mantine/core";

type Props = {
  children: React.ReactNode;
} & BadgeProps &
  MantineStyleProps;

function _Badge(props: Props) {
  const { children, ...badgeProps } = props;
  const defaultOption: BadgeProps = {
    size: "sm",
    radius: "md",
  };
  const option = Object.assign({}, defaultOption, badgeProps);
  return <MantineBadge {...option}>{children}</MantineBadge>;
}

export const Badge = createPolymorphicComponent<"button", ButtonProps>(_Badge);
